import styled from "styled-components";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { createSelector } from "reselect";
import { useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";

import globalConstants from "constants/globalConstants";

import FastStartBoxContainer from "./other/FastStartBoxContainer.js";
import BalanceBoxContainer from "./other/BalanceBoxContainer.js";

import scalelupLogo from "assets/img/logo/scalelup.svg";
import scalelupSymbolLogo from "assets/img/logo/scalelup-symbol.svg";
import StreakBox from "./other/StreakBox.js";

const Header = styled.div`
  width: 100%;
  margin: 0;

  position: relative;
  backdrop-filter: blur(6px);
  z-index: 10;
`;

const HeaderContent = styled.div`
  padding: 30px 40px;
  margin: 0 auto;
  max-width: 1600px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: ${globalConstants.switchMobile}) {
    padding: 20px;
  }
`;

const LogoWrap = styled.div`
  width: 170px;

  &:hover {
    cursor: pointer;
  }
`;

const LogoSymbolWrap = styled.div`
  width: 40px;

  &:hover {
    cursor: pointer;
  }
`;

const RightPart = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export default () => {
  const [fastStartBox, setFastStartBox] = useState(false);
  const [showFullLogo, setShowFullLogo] = useState(true);

  // // set page Title
  // useEffect(() => {
  //   document.title = "Scalelup";
  // }, []);

  const navigate = useNavigate();

  const UserProperties = createSelector(
    (state) => state.User,
    (user) => ({
      profileData: user.profileData,
      streak: user.streak,
    })
  );

  const { profileData, streak } = useSelector(UserProperties);

  const mobileScreen = useMediaQuery({
    query: `(max-width: ${globalConstants.switchMobile})`,
  });

  // console.log("profileData", profileData);

  useEffect(() => {
    if (profileData.fastStartBonus) {
      const now = new Date();
      const bonusExpires = new Date(profileData.fastStartBonus);

      if (bonusExpires.getTime() > now.getTime()) {
        const checkFastStartBox = () => {
          const now = new Date();
          const bonusExpires = new Date(profileData.fastStartBonus);

          // console.log("bonusExpires.toISOString()", bonusExpires.toISOString());
          // console.log("now.toISOString()", now.toISOString());

          if (bonusExpires.getTime() > now.getTime()) {
            setFastStartBox(true);
          } else {
            setFastStartBox(false);
          }
        };

        checkFastStartBox();

        const interval = setInterval(checkFastStartBox, 10000);

        if (mobileScreen) setShowFullLogo(false);

        return () => clearInterval(interval);
      }
    }
  }, [profileData]);

  useEffect(() => {
    if (streak > 0) {
      if (mobileScreen) setShowFullLogo(false);
    }
  }, [streak]);

  return (
    <Header>
      <HeaderContent>
        {showFullLogo && (
          <LogoWrap onClick={() => navigate("/")}>
            <img src={scalelupLogo} style={{ width: "100%" }} />
          </LogoWrap>
        )}
        {!showFullLogo && (
          <LogoSymbolWrap onClick={() => navigate("/")}>
            <img src={scalelupSymbolLogo} style={{ width: "100%" }} />
          </LogoSymbolWrap>
        )}
        <RightPart>
          {fastStartBox && <FastStartBoxContainer />}
          {streak > 0 && !fastStartBox && <StreakBox streak={streak} />}
          <BalanceBoxContainer />
        </RightPart>
      </HeaderContent>
    </Header>
  );
};
